import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";
import { useTranslation } from "react-i18next";
import Timer, { TimerStyles } from "./Timer.jsx";

export function HeaderEventStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .header-event": {
            display: "grid",
            alignItems: "center",

            "& .header-event-info": {
                display: "grid",

                "& .header-event-location": {
                    maxWidth: "350px",
                    padding: "16px 24px",
                    justifySelf: "center",

                    fontSize: "16px",
                    backgroundColor: "#000000",
                    color: "#ffffff !important",
                },

                "& .header-event-date": {
                    justifySelf: "center",

                    padding: "24px 80px",
                    fontSize: "32px",
                    border: "2px solid #000000",
                },

                "& .header-event-time": {
                    justifySelf: "center",
                    padding: "16px 24px",

                    fontSize: "16px",
                    backgroundColor: "#000000",
                    color: "#ffffff !important",
                },
            },

            [MobileBreakpoint]: {
                gridGap: "20px",

                "& h1": {
                    fontSize: "24px !important",
                    textAlign: "center !important",
                },

                "& .header-event-info": {
                    "& .header-event-location": {
                        width: "auto !important",
                        fontSize: "12px",
                    },

                    "& .header-event-date": {
                        width: "auto !important",
                        fontSize: "24px",
                    },

                    "& .header-event-time": {
                        justifySelf: "center",
                        padding: "8px 14px",

                        fontSize: "16px",
                        backgroundColor: "#000000",
                        color: "#ffffff !important",
                    },
                },
            },
        },

        ...TimerStyles(params),
    };
}
const Monthes = {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December",
};

export default function HeaderEvent(props) {
    const { t } = useTranslation();
    const LI = useLoremIpsum();

    const variables = props.variables;
    const { Events } = variables;
    const { Location, dateStart, dateEnd, timeStart, timeEnd } = Events?.[0] || LI.Events[0];

    // Date
    const startDate = new Date(dateStart).getDate();
    const startMonth = new Date(dateStart).getMonth();

    const endDate = new Date(dateEnd || dateStart).getDate();
    const endMonth = new Date(dateEnd || dateStart).getMonth();

    const notOneDay = Math.abs(endDate - startDate) > 0;
    const notOneMonth = Math.abs(endMonth - startMonth) > 0;

    // Date jsx
    const eventDateJsx = notOneDay
        ? notOneMonth
            ? `${startDate} ${t(Monthes[startMonth])} - ${endDate} ${t(Monthes[endMonth])}`
            : `${startDate} - ${endDate} ${t(Monthes[endMonth])}`
        : `${startDate} ${t(Monthes[startMonth])}`;

    // Time
    const withoutEndTime = !timeEnd || timeStart == timeEnd || new Date(timeEnd).getHours() == 0;
    const eventTimeJsx = withoutEndTime ? timeStart : `${timeStart} - ${timeEnd}`;

    if (!props.text && !props.useVariable) {
        return null;
    }

    let text = props.text;
    if (!props.text && props.useVariable) {
        if (variables[props.useVariable]) {
            text = variables[props.useVariable];
        } else {
            text = LI.Header;
        }
    }

    if (!text) {
        return null;
    }

    const elProps = toElementProps(props, { className: ["header-event"] });

    return (
        <div className="header-event">
            {dateStart && (
                <>
                    <div className="header-event-info">
                        {Location && <div className="header-event-location">{Location || ""}</div>}
                        <div className="header-event-date">{eventDateJsx}</div>
                        {eventTimeJsx && <div className="header-event-time">{eventTimeJsx}</div>}
                    </div>

                    <Timer deadlineDate={dateStart} deadlineTime={timeStart || "00:00"} />
                </>
            )}

            <h1 {...elProps}>{text || LI.Header}</h1>
        </div>
    );
}
